import React from 'react';
import _ from 'lodash';

const IsRowEqual = (prevProps, newProps) => {
  return prevProps.multiple === newProps.multiple 
    && prevProps.hidden === newProps.hidden 
    && prevProps.disabled === newProps.disabled 
    && prevProps.Id === newProps.Id
    && newProps.dataItem.inEdit === undefined
    && _.isEqual(prevProps.columns, newProps.columns)
    && _.isEqual(prevProps.selectedRowCells, newProps.selectedRowCells)
    && _.isEqual(prevProps.dataItem, newProps.dataItem);
}

export const MemoRow = React.memo((props) => {
  const {trElement} = props;
  return trElement;
}, IsRowEqual);
